import qs from 'qs';
import client from './client';

const chanceUrl = '/api/v1/project/forecast';

const commentUrl = '/api/v1/project/board';
const costCalcUrl = '/api/v1/project/expense';
const estimateUrl = '/api/v1/project/quote';
const orderUrl = '/api/v1/project/orders';

 
//매출 견적서 가져오기
export const getFiles = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`/api/v1/file/list?${queryString}`);
};

//기회 리스트 가져오기(추후에 검색어 기능 달기)
export const getChances = (searchData) => {
  const queryString = qs.stringify(searchData);
  // console.log(queryString, 'queryString');
  return client.get(`${chanceUrl}/list?${queryString}`);
};

export const getBaseChances = (searchData) => {
  const queryString = qs.stringify(searchData);
  // console.log(queryString, 'queryString');
  return client.get(`${chanceUrl}/list/base?${queryString}`);
};

//기회 추가
export const addChance = (dataToSubmit) => {
  return client.post(`${chanceUrl}/info`, dataToSubmit);
};

export const addChanceStep2 = (dataToSubmit) => {
  return client.post(`${chanceUrl}/info/step2`, dataToSubmit);
};

//기회 정보 가져오기
export const getChance = (id) => client.get(`${chanceUrl}/info/${id}`);

export const editChance = (dataToSubmit) => {
  return client.put(`${chanceUrl}/info/${dataToSubmit.prjUuid}`, dataToSubmit);
};

//포캐스팅 복사
export const copyChance = (id) => client.get(`${chanceUrl}/copy/${id}`);

//기회 삭제
export const removeChance = (id) => client.delete(`${chanceUrl}/info/${id}`);

// 삭제 권한. 본인이 만든 것이거나 삭제 권한자여야 한다.
export const getChanceDeletePermission = (id) =>
  client.get(`${chanceUrl}/info/${id}/delete-permission`);

//영업활동 가져오기
export const getComments = (id) => {
  return client.get(`${commentUrl}/prj/${id}/I`);
};

//영업이력 가져오기
export const getHistory = (id) => {
  return client.get(`${commentUrl}/prj/${id}/H`);
};

export const addComment = (dataToSubmit) => {
  return client.post(`${commentUrl}/info`, dataToSubmit);
};

export const editComment = (dataToSubmit) => {
  return client.put(
    `${commentUrl}/info/${dataToSubmit.prjUuid}/${dataToSubmit.brdUuid}`,
    dataToSubmit,
  );
};

export const removeComment = (id) => {
  return client.delete(`${commentUrl}/info/${id}`);
};

//파일 가져오기 :fileTyp => project, prjUuid
export const getChanceFiles = ({ fileTyp, fileAttrVal1 }) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

export const getPrjTechFiles = ({ fileTyp, fileAttrVal1 }) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
  });
  return client.get(`/api/v1/file/list/tech?${queryString}`);
};

export const getPurchseOrderFiles = ({
  fileTyp,
  fileAttrVal1,
  fileAttrVal2,
}) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
    fileAttrVal2,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

//매입견적서 가져오기
export const getPurchaseQuoteFiles = ({
  fileTyp,
  fileAttrVal1,
  fileAttrVal3,
}) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
    fileAttrVal3,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

//수주품의서 파일 가져오기
export const getOrderFiles = ({ fileTyp, fileAttrVal1, fileAttrVal3 }) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
    fileAttrVal3,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

//프로젝트 원가 산출 리스트
export const getCosts = (id) => {
  return client.get(`${costCalcUrl}/prj/${id}`);
};

//프로젝트 원가 등록
export const addCosts = (id, dataToSubmit) => {
  return client.post(`${costCalcUrl}/prj/${id}`, dataToSubmit);
};

//프로젝트 원가 수정
export const editCost = (dataToSubmit) => {
  return client.put(
    `${costCalcUrl}/info/${dataToSubmit.prjUuid}/${dataToSubmit.expUuid}`,
    dataToSubmit,
  );
};

//프로젝트 원가 수정
export const editCosts = (prjUuid, dataToSubmit) => {
  return client.put(`${costCalcUrl}/info/${prjUuid}`, dataToSubmit);
};

//프로젝트 원가 삭제
export const removeCost = (id) => {
  return client.delete(`${costCalcUrl}/info/${id}`);
};

//프로젝트 원가 확정
export const completeCost = (id) => {
  return client.put(`${costCalcUrl}/cost/${id}`);
};

//프로젝트 원가산출 해제
export const unDoCost = (id) => {
  return client.put(`${costCalcUrl}/cost/${id}/undo`);
};

//프로젝트 원가산출 엑셀 업로드
export const uploadExl = (formData) => {
  return client.post(`${costCalcUrl}/uploadExl`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

// 원가산출 엑셀 템플릿 다운로드 - 항상 서버에서 최신(매입처 드롭다운 포함)으로 생성한다
// (2026-10-27 cost-excel-roundtrip, owner decision 1 - 고정된 S3 템플릿 링크 대체).
export const downloadCostTemplate = () => {
  return client.get(`${costCalcUrl}/template`, {
    responseType: 'arraybuffer',
  });
};

// 원가산출 현재 내역 엑셀 다운로드 - 템플릿과 같은 칸 배치라 받아서 고친 뒤 그대로 업로드하면
// 왕복이 된다(owner decision 2).
export const downloadCostCurrent = (prjUuid) => {
  return client.get(`${costCalcUrl}/prj/${prjUuid}/download`, {
    responseType: 'arraybuffer',
  });
};

//Active한 견적서 내역 가져오기
export const getActiveEstimate = (id) => {
  return client.get(`${estimateUrl}/info/${id}/active`);
};

//프로젝트 견적서 count
export const getEstimateCount = (id) => {
  return client.get(`${estimateUrl}/info/${id}/count`);
};

//견적서 원가산출 리스트 => /api/v1/project/quote/detail/{qteUuid}
export const getEstimateCosts = (id) => {
  return client.get(`${estimateUrl}/detail/${id}`);
};

//프로젝트 견적 리스트
export const getEstimates = (id) => {
  return client.get(`${estimateUrl}/info/${id}`);
};

//견적 등록
export const addEstimate = (dataToSubmit) => {
  return client.post(`${estimateUrl}/info`, dataToSubmit);
};

//견적 수정
export const editEstimate = (dataToSubmit) => {
  return client.put(
    `${estimateUrl}/info/${dataToSubmit.prjUuid}/${dataToSubmit.qteUuid}`,
    dataToSubmit,
  );
};

//견적 삭제
export const removeEstimate = (prjId, id) => {
  return client.delete(`${estimateUrl}/info/${prjId}/${id}`);
};

//견적 엑셀
export const downloadExcel = (id) => {
  //return client.get(`${estimateUrl}/print/${id}/file`)
  return client.get(`${estimateUrl}/print/${id}/file`, {
    responseType: 'arraybuffer',
  });
};

export const downloadPdf = (id) => {
  return client.get(`${estimateUrl}/print/preview/test`, {
    responseType: 'arraybuffer',
  });
};

// 견적서 PDF 다운로드 (Excel → PDF 변환)
export const downloadQuotePdf = (id) => {
  return client.get(`${estimateUrl}/print/${id}/pdf`, {
    responseType: 'arraybuffer',
  });
};

// 견적서 PDF 미리보기 URL
export const getQuotePdfPreviewUrl = (id) => {
  const baseUrl = client.defaults.baseURL || '';
  return `${baseUrl}${estimateUrl}/print/${id}/pdf/preview`;
};

//프로젝트 수주품의서 가져오기
export const getChanceOrderHistory = (id) => {
  return client.get(`${orderUrl}/list/${id}`);
};

//프로젝트의 활성화된 수주 확인
export const getChanceOrderCount = (id) =>
  client.get(`${orderUrl}/list/${id}/count`);

// 기회 번호 하나로 UUID 와 단계를 받아온다.
// /chancemng/no/BI_PJ_2026_09_005 같은 주소를 상세 화면으로 넘길 때 쓴다.
export const getChanceByNo = (prjNo) =>
  client.get(`${chanceUrl}/by-no?${qs.stringify({ prjNo })}`);

// 수주품의서 번호로 소속 기회를 찾는다. 수주는 따로 열리는 화면이 없어서 기회로 보낸다.
export const getChanceByRoNo = (roNo) =>
  client.get(`${chanceUrl}/by-ro-no?${qs.stringify({ roNo })}`);
